<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">Acknowledgements</p>
<p class="noindent">This book has been a project in the making for over a decade. I’ve loved LeDroit Park since 2011 but focused on developing my knowledge of more commercially viable neighborhoods for a tour guide, like Georgetown. Fast-forward to 2020. I thought a worldwide pandemic with two preschoolers’ home from school would be the ideal time to write a new book. I had research appointments rescheduled more than a dozen times due to library closures. I am forever grateful for everyone who digitized countless directories, congressional records, and meeting minutes from the nineteenth and twentieth centuries. The final pages of this book were made while my entire family had COVID and were written while I was a nurse, housekeeper, cook, playmate—and sick.</p>
<p class="indent">To my fellow working moms, especially those in LIFO, I did it!</p>
<p class="indent">To my kids, Mahler and Emyn, who asked me, “Can you read your book to me at bedtime?” and then changed their minds when I said there were no pictures.</p>
<p class="indent">To my husband, Manny, who encouraged me to do this when I regretted it. Frequently.</p>
<p class="indent">To my colleagues and friends at DC by Foot, who helped and inspired me in my research and answered my questions related to, “What would you like to know about LeDroit Park?”</p>
<p class="indent">And to you, the reader, who wanted to learn more about this historic and beautiful neighborhood. I present to you my pandemic project.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?66250e25